<template>
  <div class="bg-white border-solid border-0 border-l border-gray-a10 h-full flex flex-col px-4 pt-4">
    <BaseToggleGroup class="mt-4" :tabs="tabs" v-model="activeTab" />

    <BaseCallout
      v-if="action.isFallback"
      class="mt-6"
      text='FALLBACK: Nothing found in custom knowledge base. Knowledge type "General" was used to handle the request.'
    />

    <div class="mt-6 overflow-y-auto" v-bar>
      <!-- General: ChatGPT config without prompts -->
      <ChatGPTEditor
        v-if="activeTab === 'general'"
        :cachedAction="action"
        :hideSections="true"
        :isDisabled="true"
        class="pr-6"
      />

      <!-- Prompt: system, user, search metadata, message history -->
      <ChatGPTActionDetailPrompt
        v-if="activeTab === 'prompt'"
        :action="action"
        :formData="formData"
        class="pr-6"
      />

      <!-- API: options, message history,response body, intent labels, citations -->
      <ChatGPTActionDetailApi
        v-if="activeTab === 'api'"
        :formData="formData"
      />
    </div>
  </div>
</template>

<script>
import ChatGPTEditor from '@/components/editor/ChatGPTEditor.vue'
import ChatGPTActionDetailPrompt from './ChatGPTActionDetailPrompt.vue'
import ChatGPTActionDetailApi from './ChatGPTActionDetailApi.vue'

export default {
  name: 'ChatGPTActionDetail',
  components: { ChatGPTEditor, ChatGPTActionDetailPrompt, ChatGPTActionDetailApi },

  props: {
    formData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      activeTab: 'general'
    }
  },

  computed: {
    tabs() {
      return [
        { key: 'general', label: 'General' },
        { key: 'prompt', label: 'Prompt' },
        { key: 'api', label: 'API' }
      ]
    },

    action() {
      return this.formData?.data?.action
    }
  }
}
</script>
